import "../styles/globals.css";
import type { AppProps } from "next/app";
import React from "react";
import { GtmScript } from "components/layout/GoogleTagManager";

function MyApp({ Component, pageProps }: AppProps) {
  return (
    <>
      <GtmScript />
      <Component {...pageProps} />
    </>
  );
}

export default MyApp
